import { render, staticRenderFns } from "./TaxRateSetting.vue?vue&type=template&id=6254fc60&"
import script from "./TaxRateSetting.vue?vue&type=script&lang=js&"
export * from "./TaxRateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6254fc60')) {
      api.createRecord('6254fc60', component.options)
    } else {
      api.reload('6254fc60', component.options)
    }
    module.hot.accept("./TaxRateSetting.vue?vue&type=template&id=6254fc60&", function () {
      api.rerender('6254fc60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/TaxRateSetting.vue"
export default component.exports